import { render, staticRenderFns } from "./Organizational.vue?vue&type=template&id=76f8fe29"
import script from "./Organizational.vue?vue&type=script&lang=js"
export * from "./Organizational.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports